<template>
  <div class="form-page">
    <div class="form-page__header">
      <h2 class="form-page__title">Angaben prüfen</h2>
      <p class="form-page__subtitle">
        Bitte tragen Sie Ihre persönlichen Angaben ein. Diese Felder werden nicht automatisch aus
        Ihren Dokumenten ausgelesen.
      </p>
    </div>

    <div class="form-section">
      <h3 class="section-title">Persönliche Angaben</h3>
      <div class="field-group">
        <div class="field-row field-row--2">
          <div class="field">
            <label class="field__label">Vorname <span class="required-mark">*</span></label>
            <input
              type="text"
              class="field__input"
              :class="{ 'field--error': showErrors && !modelValue.vorname }"
              placeholder="Vorname"
              :value="modelValue.vorname"
              @input="update('vorname', $event.target.value)"
            />
            <p v-if="showErrors && !modelValue.vorname" class="field__error">Pflichtfeld</p>
          </div>

          <div class="field">
            <label class="field__label">Nachname <span class="required-mark">*</span></label>
            <input
              type="text"
              class="field__input"
              :class="{ 'field--error': showErrors && !modelValue.nachname }"
              placeholder="Nachname"
              :value="modelValue.nachname"
              @input="update('nachname', $event.target.value)"
            />
            <p v-if="showErrors && !modelValue.nachname" class="field__error">Pflichtfeld</p>
          </div>
        </div>

        <div class="field-row field-row--2">
          <div class="field">
            <label class="field__label">Geburtsdatum <span class="required-mark">*</span></label>
            <input
              type="date"
              class="field__input"
              :class="{ 'field--error': showErrors && !modelValue.geburtsdatum }"
              :value="modelValue.geburtsdatum"
              @input="update('geburtsdatum', $event.target.value)"
            />
            <p v-if="showErrors && !modelValue.geburtsdatum" class="field__error">Pflichtfeld</p>
          </div>

          <div class="field">
            <label class="field__label">Geburtsort <span class="required-mark">*</span></label>
            <input
              type="text"
              class="field__input"
              :class="{ 'field--error': showErrors && !modelValue.geburtsort }"
              placeholder="Geburtsort"
              :value="modelValue.geburtsort"
              @input="update('geburtsort', $event.target.value)"
            />
            <p v-if="showErrors && !modelValue.geburtsort" class="field__error">Pflichtfeld</p>
          </div>
        </div>

        <div class="field">
          <label class="field__label">E-Mail-Adresse <span class="required-mark">*</span></label>
          <input
            type="email"
            class="field__input"
            :class="{ 'field--error': showErrors && !modelValue.email }"
            placeholder="beispiel@email.de"
            :value="modelValue.email"
            @input="update('email', $event.target.value)"
          />
          <p v-if="showErrors && !modelValue.email" class="field__error">Pflichtfeld</p>
        </div>

        <div class="field">
          <label class="field__label">Mobiltelefon <span class="required-mark">*</span></label>
          <input
            type="tel"
            class="field__input"
            :class="{ 'field--error': showErrors && !modelValue.mobil }"
            placeholder="+49 170 1234567"
            :value="modelValue.mobil"
            @input="update('mobil', $event.target.value)"
          />
          <p v-if="showErrors && !modelValue.mobil" class="field__error">Pflichtfeld</p>
        </div>
      </div>
    </div>

    <p class="required-note"><span class="required-mark">*</span> Pflichtfelder</p>
  </div>
</template>

<script>
export default {
  name: 'BaumAngabenStep',
  props: {
    modelValue: { type: Object, required: true },
    showErrors: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const update = (key, val) => emit('update:modelValue', { ...props.modelValue, [key]: val });
    return { update };
  },
};
</script>

<style scoped src="../form.css"></style>
